import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaskedTextBoxModule, NumericTextBoxAllModule, NumericTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { MultiselectDropdownModule } from 'angular-2-dropdown-multiselect';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { ColumnChooserService, DetailRowService, FilterService, GridModule, PageService, ResizeService, SortService } from '@syncfusion/ej2-angular-grids';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { MyDatePickerModule } from 'mydatepicker';
import { TransactionVerificationComponent } from './transaction-verification.component';
import { TransactionVerficationRoutingModule } from './transaction-verification-routing.module';


@NgModule({
  declarations: [TransactionVerificationComponent],
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule,
    GridModule,
    ReactiveFormsModule,
    MultiselectDropdownModule,
    NumericTextBoxModule,
    NumericTextBoxAllModule,
    NgxUiLoaderModule,
    MaskedTextBoxModule, 
    MyDatePickerModule,
    TransactionVerficationRoutingModule
    
  ],
  providers:[ColumnChooserService,PageService,SortService,FilterService,ResizeService,DetailRowService],
  schemas:[NO_ERRORS_SCHEMA]
})
export class TransactionVerificationModule { }
